export default __webpack_public_path__ + "static/media/right-arrow.339f71ca.png";